module.exports = __webpack_public_path__ + "static/media/rhicp.3445f550.png";